/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 *  - STATUS_APPROVED: Трейдер утверждает что выполнил выплату, и ожидает одобрения.
 */
export enum PayoutCommonOrderTraderOrderV1Status {
    STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED',
    STATUS_WAITING_REACTION = 'STATUS_WAITING_REACTION',
    STATUS_IN_WORK = 'STATUS_IN_WORK',
    STATUS_DECLINED = 'STATUS_DECLINED',
    STATUS_EXPIRED = 'STATUS_EXPIRED',
    STATUS_COMPLETE = 'STATUS_COMPLETE',
    STATUS_ALREADY_TAKEN = 'STATUS_ALREADY_TAKEN',
    STATUS_INVESTIGATION = 'STATUS_INVESTIGATION',
    STATUS_APPROVED = 'STATUS_APPROVED',
    STATUS_INVESTIGATION_APPROVED = 'STATUS_INVESTIGATION_APPROVED',
    STATUS_INVESTIGATION_DECLINED = 'STATUS_INVESTIGATION_DECLINED',
    STATUS_SPLIT = 'STATUS_SPLIT',
    STATUS_CANCELLED = 'STATUS_CANCELLED',
}
